// Which roster mate this device says you are, per receipt. Device-only: it's
// never written to the receipt, so any number of devices can be the same mate
// (their edits to that mate's portions all sync through the item writes).
const keyFor = (receiptId: string) => `checkmates.claim.${receiptId}`;

export function getLocalIdentity(receiptId: string): string | null {
  try {
    return localStorage.getItem(keyFor(receiptId));
  } catch {
    return null;
  }
}

export function setLocalIdentity(
  receiptId: string,
  userId: string | null
): void {
  try {
    if (userId) localStorage.setItem(keyFor(receiptId), userId);
    else localStorage.removeItem(keyFor(receiptId));
  } catch {
    // storage unavailable — ignore
  }
}
